import { Popup as AkPopup, type PopupProps as AkPopupProps } from '@atlaskit/popup';

import { wrapToggleableComponentForChoreographer } from '../utils';

export const Popup = wrapToggleableComponentForChoreographer<AkPopupProps>(AkPopup, 'isOpen');
